import React from "react";

import { Link } from "react-router-dom";

function Bigdata() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>AI&BIG DATA</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">빅데이터 플랫폼</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="feature-style-1">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 company">
              <div className="company-tab">
                <ul className="nav nav-pills nav-justified">
                  <li>
                    <Link data-toggle="pill" to="/ai">
                      AI 관제 서비스{" "}
                    </Link>
                  </li>
                  <li className="active">
                    <Link data-toggle="pill" to="/bigdata">
                      빅데이터 플랫폼{" "}
                    </Link>
                  </li>
                  <li>
                    <Link data-toggle="pill" to="/fusion">
                      빅데이터 융합 서비스{"  "}
                    </Link>
                  </li>
                  {/* <li>
                    <Link data-toggle="pill" to="tmap">
                      T-map API{"  "}
                    </Link>
                  </li> */}
                </ul>
                <div className="tab-content">

                <div className='tab_content_area'>
                                <div className="tab_title">
                                    빅데이터 플랫폼
                                </div>
                                <div className='tab_paragraph'>
                                    <p>개요</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- SKTelecom 보유중인 인구 통계 데이터로 전국민을 모집단으로 하는 인구 표본 데이터</li>
                                            <li>- 전국민 대비 약 50% 이상의 표본 비율 보유로 정확도가 높음</li>
                                            <li>- 공공분야 약 200여개 이상의 사업과 다수의 빅데이터 플랫폼에서 구축 및 활용 중</li>
                                        </ul>
                                </div>
                                <div className='tab_paragraph'>
                                    <p>특장점</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- 빅데이터 플랫폼인 Geovision으로 공공 및 민간 니즈에 부합하는 맞춤형 데이터셋 보유</li>
                                            <li>- 국내 유일 전파영역관리시스템을 통한 공간해상도 50m X 50m Smart Grid 제공으로 Zone Base 인구 데이터 추출 용이</li>
                                            <li>- 네트워크 방식 위치 기반 솔루션 ‘pCELL’을 통해 타 통신사 대비 5배 이상 정밀한 인구 데이터 제공</li>
                                        </ul>
                                    <div>
                                        <div className='servicePostBox2'>
                                            <div>
                                                <img src='./images/service/Ai2/image14.png' alt=''/>
                                                <p>전파영역관리시스템 (전파지향성, 전파영역 관리)</p>
                                            </div>
                                            <div style={{position:'relative',marginLeft:'20px',marginRight:'5px'}}>
                                                <img src='./images/service/Ai2/image15.png' alt=''/>
                                                <p>SKT Data 경복궁 분석 영역</p>
                                                <div className='versus'>VS</div>
                                            </div>
                                            <div>
                                                <img src='./images/service/Ai2/image12.png' alt=''/>
                                                <p>타사 경복궁 분석 영역</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='tab_paragraph'>
                                    <p>데이터 종류</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- 유동/유입인구 데이터를 표출 조건에 맞게 활용 가능하며 WEB 기반의 시각화 서비스 제공</li>
                                        </ul>
                                    <div className='tab_table1'>
                                        <table>
                                            <thead>
                                                <tr>
                                                    {/* 상위 태그에 left 정렬이 있어서 수동으로 센터로 잡음 */}
                                                    <th scope='col'><center>데이터명</center></th>
                                                    <th scope='col'><center>데이터셋</center></th>
                                                    <th scope='col'><center>표출 조건</center></th>
                                                    <th scope='col'><center>공간해상도</center></th>
                                                    <th scope='col'><center>활용범위</center></th>
                                                    <th scope='col'><center>비고</center></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope='row' rowSpan='3' className='data1'><center>SKT 유동인구</center></th>
                                                    <td>시간대별</td>
                                                    <td>1시간 단위</td>
                                                    <td rowSpan='3'>50m X 50m, <br/> pCEL 단위</td>
                                                    <td rowSpan='3'>1.상권분석<br/>2.인구 분석<br/>3.시설물 배치 등</td>
                                                    <td rowSpan='3'>자치구 시군구단위로 제공<br/>(또는 특정 임의 분석 영역은 협<br/>의 후 지원)</td>
                                                </tr>
                                                <tr>
                                                    <td>성연령별</td>
                                                    <td>남녀 10세 단위</td>
                                                </tr>
                                                <tr>
                                                    <td>요일별</td>
                                                    <td>일단위 요일별 평균</td>
                                                </tr>
                                                <tr>
                                                    <th scope='row' rowSpan='3' className='data1'><center>SKT 유입인구</center></th>
                                                    <td>유입지별</td>
                                                    <td>행정동 단위</td>
                                                    <td rowSpan='3'>50m X 50m, <br/> pCEL 단위</td>
                                                    <td rowSpan='3'>1.관광 분석<br/>2.교통 분석<br/>3.특정시설<br/>방문객 분성 등</td>
                                                    <td rowSpan='3'>자치구 시군구단위로 제공<br/>(또는 특정 임의 분석 영역은 협<br/>의 후 지원)</td>
                                                </tr>
                                                <tr>
                                                    <td>성연령별</td>
                                                    <td>남녀 10세 단위</td>
                                                </tr>
                                                <tr>
                                                    <td>월별 일평균</td>
                                                    <td>월별 주중/주말 일평균</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='tab_paragraph'>
                                    <p>적용 사례</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- 세종시, 서울시 은평구, 대전시 유성구 등 쓰레기 무단투기 단속 및 대전광역시 이상징후 실증 적용</li>
                                        </ul>
                                        <div className='servicePostBox3'>
                                            <div>
                                                <img src='./images/service/Ai2/image16.png' alt=''/>
                                                <p>파주시 관광객 이동 동선 분석</p>
                                            </div>
                                            <div>
                                                <img src='./images/service/Ai2/image17.png' alt=''/>
                                                <p>대중교통 노선 분석</p>
                                            </div>
                                            <div>
                                                <img src='./images/service/Ai2/image18.png' alt=''/>
                                                <p>Geovision 상권 분석</p>
                                            </div>
                                            <div>
                                                <img src='./images/service/Ai2/image19.png' alt=''/>
                                                <p>광고 효과 분석</p>
                                            </div>
                                        </div>
                                </div>
                            </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Bigdata;
